import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setGroupModalAttributes } from "src/actions/group";
import Icon from "src/components/Icon";
import { getGroup } from "src/reducers";
import * as colors from "src/styles/constants/colors";
import { iconSize } from "src/styles/constants/size";
import { AppState } from "src/types";
import { EditButtonContainer } from "./styles";

interface Props {
  id: number;
  onEdit: (id: number) => void;
}

const EditButton = ({ id, onEdit }: Props): React.ReactElement => {
  const dispatch = useDispatch();
  const group = useSelector(({ app }: { app: AppState }) => getGroup(app, id));

  const handleEdit = () => {
    if (!group) return;

    const { title, photoUrl, owners, members, locked } = group;
    dispatch(
      setGroupModalAttributes({
        title,
        photoUrl,
        owners,
        members,
        locked,
        id,
        edit: true,
        show: true,
        error: null,
        loading: false,
      }),
    );
    onEdit(id);
  };

  return (
    <EditButtonContainer onClick={handleEdit}>
      <Icon icon="edit" size={iconSize.space_s} color={colors.primary} />
    </EditButtonContainer>
  );
};

export default EditButton;
